module.exports = __webpack_public_path__ + "images/trendUpIcon-f43588a326190a6704338b4008e13b73.svg";